import { Component, OnInit, HostListener } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { ApiService } from '../api.service';
import { PdfService } from '../pdf.service';
import { Router } from '@angular/router';
import { LocationService } from '../location.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-review-items',
  templateUrl: './review-items.component.html',
  styleUrls: ['./review-items.component.scss'],
})
export class ReviewItemsComponent {
  quotationObj: any;
  category;
  purrchaseItems: any;
  recPayStatus:boolean=false;
  orderConfirmPop:boolean=false;
  promotions:any=[];
  itemCategoryObj:any=[];
  region;
  country;
  state;
  docId;
  typeDoc;
  orderItems:any=[];
  city;
  dateFormat;
  categoryCode;
  id;
  openpop: boolean = false;
  bigpop: boolean = false;
  openEdit: boolean = false;
  recPay:boolean = false;
  editItem: any;
  img;
  frmScan: boolean = false;
  openReturn: boolean = false;
  barpop: boolean = false;
  returnItem1: any = [];
  returnItem2: any = [];
  allItems: any = [];
  returnImg;
  percent: any;
  percent1: any;
  discountPercent;
  discountAmt;
  creditCheck: boolean = true;
  couponCheck:boolean =true;
  openScanner: boolean = false;
  reasonId;
  fontStyle;
  reasonName;
  openExchange: boolean = false;
  item;
  newitem;
  typeCode;
  pic;
  typeName;
  url;
  header1;header2;
  returnCheck: boolean=false;
  curntItem: any = {};
  newItem: any = {};
  header;
  name;
  qty;
  ItemOrders:any=[];
  amount;
  Price;
  Quantity;
  headLang = localStorage.getItem('lang');
  reasons: any = [{ id: 1, name: "Size didnt fit" },
  { id: 2, name: "Color didnt match" },
  { id: 3, name: "Style isnt good" },
  { id: 4, name: "Didnt like it" },
  { id: 5, name: "Damaged" }];
  paymentMode: any = [{ id: 1, name: "Cash" },
  { id: 4, name: "Cheque" },{ id: 5, name: "Google Pay" },{id: 7, name: "Phonepe"},{id: 8, name: "Paytm"}];
  paymentId;
  paymentName;
  paymentStatus: any = [{ id: 2, name: "Paid" },
  { id: 1, name: "Not Paid" }];
  paymentStatusName;
  paymentStatusId;
  amountPaid;
  adjustedAmt;
  reason;
  active: boolean = false;
  show:boolean=false;
  squareFeet:boolean;
  nonSquareFeet:boolean;
  cateCode;
  refNo;
  msg;
  notes;
  delRegion;
  pendingAmt;
  edit:boolean = true;
  userValue;
  criditValue;
  config;
  config1;
  userDetails;
  data;
  itemTypeId;
  recstatus:boolean;
  payId;
  pendingpay:boolean;
  couponcode:boolean;
  credits:boolean;
  memCount: any;

  constructor(private service: ApiService, public pdf: PdfService,
    public router: Router, public auth: AuthService, public location: LocationService,
    private handler: HandlerService, 
    protected sanitizer: DomSanitizer,  
    private bottomSheet: MatBottomSheet) { }


  async ionViewWillEnter() {
    this.url = window.location.href;
    this.fontStyle=localStorage.getItem('lang'); 
    this.pdf.loader = true;
     this.cateCode = sessionStorage.getItem('cateCode') 
    this.dateFormat = this.auth.getDateformat();
    if(this.url.includes('review-items')){
      this.id = localStorage.getItem('orderId');
    }else{
      this.id = this.url.split('/').pop();
    }
    if(this.url.includes('record-pay') || this.url.includes('home-record-pay')){
      this.recPay=true;
    }else{
      this.recPay=false;
    }
    if(this.url.includes('saved-items')){
      this.edit = false;
    }
    if(this.url.includes('pending-pay')){
      this.pendingpay=false;
    }else{
      this.pendingpay=true;
    }
    this.getConfig();
    this.getUser();
    this.service.getOrderById(this.id).subscribe((res:any) => {
      if (res) {
        localStorage.setItem('shopId',res.orgId)
        this.purrchaseItems = res;
        this.memCount = res.membershipDiscountAmntStr;
        this.pdf.loader = false; 
        this.ItemOrders = res.itemOrders;
        var x;
        x = this.ItemOrders[this.ItemOrders.length-1].itemTypeId;
        this.itemTypeId = x;
        this.delRegion = res.delRegion; 
        this.notes = res.notes;       
        this.orderItems = res.orderItems; 
        if(res.paymtStatus==2){
          this.recstatus=false
        }else{
          this.recstatus=true
        }
        if(this.url.includes('saved-items') && res.creditPoints){
          this.removeCredit();
        }
        if(this.url.includes('saved-items') && res.couponCode){
          this.remove();
        }
        this.paymentId = res.paymtMode;
        this.paymentStatusId = res.paymtStatus;
        // this.amountPaid=res.amountPaid;
        this.refNo=res.paymtRef;
        this.adjustedAmt=res.adjustedPayTotal;
       this.reason=res.adjustedComments;
        this.active= res.adjusted;
        this.pendingAmt=res.balanceAmount;
        if(res.couponCode){
          this.couponcode = true;
        }else{
          this.couponcode = false;
        } 
        if(res.creditPoints){
          this.credits=true;
        } else{
          this.credits=false;
        }
        this.paymentMode.map(res=>{       
          if(res.id == this.paymentId ){
            this.paymentName = res.name;
            this.paymentId = res.id;
          }
          this.ItemOrders.map(res1=>{
            Object.assign(res1,{billPostVisit:res1.itemDetails.billPostVisit})
          })
         this.squareFeet= this.ItemOrders.every(dat1=>{
            return  dat1.billPostVisit==true
          })
          this.nonSquareFeet= this.ItemOrders.every(dat1=>{
            return  dat1.billPostVisit==false
          })
        })
        this.paymentStatus.map(res=>{
          if(res.id == this.paymentStatusId){
            this.paymentStatusName = res.name
          } 
        })         
        // this.pdf.loader = false; 
            this.payId = this.id;   
            this.amountPaid = "" ;
      }
      this.getCategory(res.categoryId);
    },
      err => {
        this.pdf.loader = false;
        this.handler.err(err.error)
      })

   
  }
  getCategory(id){
    this.service.getCategoryById(id).subscribe((res:any)=>{
      if(res){
        this.userValue=res.billPostCost;
      }
    })
  }
  getOrderById(){
    this.service.getOrderById(this.id).subscribe((res:any) => {
      if (res) {
        localStorage.setItem('shopId',res.orgId)
        this.purrchaseItems = res;
        this.pdf.loader = false; 
        this.ItemOrders = res.itemOrders;
        var x;
        x = this.ItemOrders[this.ItemOrders.length-1].itemTypeId;
        this.itemTypeId = x;
        this.delRegion = res.delRegion; 
        this.notes = res.notes;       
        this.orderItems = res.orderItems; 
        if(res.paymtStatus==2){
          this.recstatus=false
        }else{
          this.recstatus=true
        }
        this.paymentId = res.paymtMode;
        this.paymentStatusId = res.paymtStatus;
        // this.amountPaid=res.amountPaid;
        this.refNo=res.paymtRef;
        this.adjustedAmt=res.adjustedPayTotal;
       this.reason=res.adjustedComments;
        this.active= res.adjusted;
        this.pendingAmt=res.balanceAmount;
        if(res.couponCode){
          this.couponcode = true;
        }else{
          this.couponcode = false;
        } 
        if(res.creditPoints){
          this.credits=true;
        } else{
          this.credits=false;
        }
        this.paymentMode.map(res=>{       
          if(res.id == this.paymentId ){
            this.paymentName = res.name;
            this.paymentId = res.id;
          }
          this.ItemOrders.map(res1=>{
            Object.assign(res1,{billPostVisit:res1.itemDetails.billPostVisit})
          })
         this.squareFeet= this.ItemOrders.every(dat1=>{
            return  dat1.billPostVisit==true
          })
          this.nonSquareFeet= this.ItemOrders.every(dat1=>{
            return  dat1.billPostVisit==false
          })
        })
        this.paymentStatus.map(res=>{
          if(res.id == this.paymentStatusId){
            this.paymentStatusName = res.name
          } 
        })         
        // this.pdf.loader = false; 
            this.payId = this.id;       
      }
      this.getCategory(res.categoryId);
    },
      err => {
        this.pdf.loader = false;
        this.handler.err(err.error)
      })
  }
  getUser(){
    this.service.getUserDetailsById(localStorage.getItem('currentUserId')).subscribe((res:any)=>{
      this.userDetails = res;
    })
  }

  async getConfig(){
    this.data= await this.service.getConfig().toPromise();
    if(this.data){
       let x= this.data.find(res=>res.name=="Billing Config");
      //  this.config=x.configs.find(dat=>dat.shortCdConst=="TVC");
       this.config1 = x.configs.find(dat=>dat.shortCdConst=="ACP");
      //  this.userValue=this.config.userValue; 
       this.criditValue=this.config1.userValue;

    }
  }

  pay() {
    sessionStorage.setItem('PayCost', this.purrchaseItems.orderAmountStr)
    localStorage.setItem('updateOrderId',this.id)
    if(this.url.includes('pending-pay')){
      this.router.navigate(['orders-pay-options/',this.id])
    }else{  
    this.router.navigate(['order-payment'])
    }
  }

  updatePay(){
    this.UpdateService();
    sessionStorage.setItem('PayCost', this.purrchaseItems.orderAmountStr)
    localStorage.setItem('updateOrderId',this.id)
    if(this.url.includes('pending-pay')){
      this.router.navigate(['orders-pay-options/',this.id]) 
    }else{
      this.router.navigate(['order-payment']) 
    }
  }

 
  ionViewWillLeave() {
    this.pdf.popup = false;
    this.pdf.loader = false;
    this.openEdit = false;
    let h: any = document.getElementById('hidden');
    if(h)
    h.style.visibility = "visible";
    let h1: any = document.getElementById('pop');
    if(h1)
    h1.style.visibility = "visible";
    this.openScanner = false;
    this.curntItem = undefined;
    sessionStorage.setItem('orderValue',this.purrchaseItems.orderAmountStr)
    this.newItem = undefined;
    this.item = undefined;
    this.returnItem1=[];
    this.returnItem2=[];
    this.frmScan=false;
    this.amountPaid="";
  }
  email() {
    Object.assign(this.purrchaseItems, { header: "BILL", subheader: "BILL #:" })
    // this.pdf.generatePdf(this.purrchaseItems);
  }

  returnItems(item, id) {
    this.pdf.loader=true;
    this.curntItem = item;
     this.service.getItemById(item.id).subscribe((res:any)=>{
      if(res.img)
      Object.assign(item,{img:res.img})
      this.pdf.loader=false;
      if(id==1){
        this.openExchange = true;
      setTimeout(() => {
        document.getElementById('upc1').focus()
      }, 500);
      }
      if (id == 2){
        this.openReturn = true;
      }
    },
    err=>{
      this.pdf.loader=false;
      this.handler.err(err);
      this.openReturn=false;
      this.openExchange=false;
    })


  }


 
  openBottomSheetReason(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.reasons,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.reasonName = res.name;
      this.reasonId = res.id;
    });
  }

  getAllItems() {
    this.pdf.loader = true;
    this.barpop = false;
    this.service.getAllItems().subscribe(res => {
      this.allItems = res;
      this.bigpop = true;
      this.pdf.loader = false;

    })
  }

  recordPay(){
    var post1 ={     
      paymentRcvdBy: localStorage.getItem("currentUserId"),    
      paymtStatus:2,
      amountPaid:this.amountPaid,
      adjustedPayTotal:this.adjustedAmt,
      adjustedComments:this.reason,
      adjusted:this.active,
      paymtAmt:this.purrchaseItems.orderAmountStr ,
      paymtMode:this.paymentId,
      paymtRef:this.refNo,
      invoiceNotes:this.msg,
    } 
    this.service.postOrderPaymentDetails(this.id,post1).subscribe((res:any)=>{
      this.handler.res("Payment Details Added SuccessFully");     
      if(this.url.includes('record-pay')){
        this.router.navigate(['/admin-manage-order']);   
      }else{
        this.router.navigate(['/vendor-manage-order']);   
      }    
    })
  }

  recordPay1(){
    var post1 ={     
      paymentRcvdBy: localStorage.getItem("currentUserId"),    
      paymtStatus:this.paymentStatusId,
      amountPaid:this.amountPaid,
      adjustedPayTotal:this.adjustedAmt,
      adjustedComments:this.reason,
      adjusted:this.active,
      paymtAmt:this.purrchaseItems.orderAmountStr ,
      paymtMode:this.paymentId,
      paymtRef:this.refNo,
      invoiceNotes:this.msg,
    } 
    this.service.postOrderPaymentDetails(this.id,post1).subscribe((res:any)=>{
      this.handler.res("Payment Details Added SuccessFully");     
      if(this.url.includes('record-pay')){
        this.router.navigate(['/admin-manage-order']);   
      }else{
        this.router.navigate(['/vendor-manage-order']);   
      }     
    })
  }

  openBottomSheet(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.paymentMode,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.paymentId = res.id;
      this.paymentName = res.name;
      if(this.paymentId==4 || this.paymentId==5 || this.paymentId==7 || this.paymentId==8){
        this.show=true;
        this.refNo="";
      }else{
        this.show=false;
      }
    });
  }

  openBottomSheetStatus(){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.paymentStatus,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.paymentStatusId = res.id;
      this.paymentStatusName = res.name;
      if(this.paymentStatusId==1){
        this.amountPaid="";
        this.refNo="";
        this.paymentId="";
        this.paymentName="";
      }else{
        this.paymentId = this.purrchaseItems.PaymtMode;
        this.paymentStatusId = this.purrchaseItems.paymentStatus;
        // this.amountPaid=this.purrchaseItems.amountPaid;
        this.refNo=this.purrchaseItems.PaymtRef;
        this.paymentMode.map(res=>{
          if(res.id == this.paymentId ){
            this.paymentName = res.name
          }
        })
        this.paymentStatus.map(res=>{
          if(res.id == this.paymentStatusId ){
            this.paymentStatusName = res.name
          }
        })
      }
    });
  }

  cancel(){
    if(this.url.includes('saved-items')){
      this.router.navigate(['/savedOrders']);  
    }else if(this.url.includes('record-pay')){
        this.router.navigate(['/admin-manage-order']);   
      }else if(this.url.includes('pending-pay')){
        this.router.navigate(['/mybookings1']);
      }else if(this.url.includes('home-record-pay')){
        this.router.navigate(['/vendor-manage-order']);   
      }
      else{
        this.router.navigate(['/req-booking' ])    
      }
 
  }

  updateOrder(data) {  
    this.pdf.loader=true;
    data.qty = 1;
    let products = {      
      "orderItems" :[
        {
            "id" : data.itemId,
            "qty" :data.qty,
            "billPostVisit":data.billPostVisit
            
        }
    ],
    providerServiceId:data.itemId,
      region:this.delRegion, 
      orderType : 1,
      itemTypeId:data.itemTypeId,
      cnvcChargeApplied:true, 
    }
        this.service.orderItemPost(this.id, data.itemId, products).subscribe((res:any) => {
       if(res){
         // this.getOrder(this.orderId);
           this.orderItems = res;        
            this.getOrderById();
           }
     },
       err => {
               this.handler.err(err)
       })
   }
 
   async updateOrderItem(data){
     this.pdf.loader=true;
    //  data.qty = data.qty-1;
     data.qty = 1;
     let products = {      
      "orderItems" :[
        {
            "id" : data.itemId,
            "qty" :data.qty,
            "billPostVisit":data.billPostVisit
        }
    ],
    providerServiceId:data.itemId,
      region:this.delRegion, 
      orderType : 1,
      itemTypeId:data.itemTypeId,
      cnvcChargeApplied:true, 
    }
       this.service.updateOrderItem(this.id, data.itemId, products).subscribe(res => {
         if(res){
           this.orderItems = res;
           this.getOrderById();        
          } 
       },
         err => {
                this.handler.err(err)
         })
     }
 
     continueShopping(){
       if(this.url.includes('saved-items')){
         if(localStorage.getItem('orderId') != this.purrchaseItems.id && localStorage.getItem('orderId')){
          this.orderConfirmPop=true;
         }else{
          this.clear();
         }      
            }else{
        this.router.navigate(['/edit-services'])
       }    
     }



     itemCategory1(){
      this.service.getOrgCategory().subscribe(res=>{
        this.category = res; 
        this.category.map(res1=>{
          if(res1.id==this.purrchaseItems.categoryId){
            this.categoryCode = res1.code;
          }
          sessionStorage.setItem('cateCode',this.categoryCode) 
        })
       })
        }


     clear(){
       this.getItemType();
      this.itemCategory1();
      this.getLocationDetails();
       localStorage.setItem('orderId',this.purrchaseItems.id)
       sessionStorage.setItem('orderLen',this.purrchaseItems.itemOrders.length)
       localStorage.setItem('cateId',this.purrchaseItems.categoryId)
       sessionStorage.setItem("categoryId",this.purrchaseItems.categoryId)
       sessionStorage.setItem('region',this.purrchaseItems.delRegion)
       sessionStorage.setItem('itemCatEdit',this.purrchaseItems.categoryId)
   this.router.navigate(['/edit-services'])
     }


     getDoc(data){
      this.service.getAdImage(data).subscribe(res => {
        this.pic = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
      })
    }
 
     getItemType(){
      this.service.getItemType().subscribe((res: any)=>{
        this.itemCategoryObj= res;  
      this.itemCategoryObj.map(res1=>{
        if(res1.id==this.itemTypeId){
          this.typeName=res1.name;
          this.typeCode =res1.code;
          this.docId = res1.docId;
        }
        if(this.docId)  {
          this.getDoc(this.docId);
          this.typeDoc=this.docId;
          sessionStorage.setItem('tDoc',this.typeDoc);  
        }
        sessionStorage.setItem('itemTypeId',this.itemTypeId); 
        sessionStorage.setItem('itemTypeEdit',this.itemTypeId);
        sessionStorage.setItem('itemItpeName',this.typeName);
      sessionStorage.setItem('tName',this.typeName);
      sessionStorage.setItem('tImg',this.pic);
      })
      })
    }

    Stay(){
      this.orderConfirmPop=false;
    }


    getLocationDetails(){
      if(this.purrchaseItems.delCity=="Chennai" || this.purrchaseItems.delCity=="chennai" || this.purrchaseItems.delCity=="CHENNAI" || 
      this.purrchaseItems.delCity=="Thiruvallur" ||this.purrchaseItems.delCity=="thiruvallur"|| this.purrchaseItems.delCity=="THIRUVALLUR"){
      var post={
        "id":790,
        "city":this.purrchaseItems.delCity
      }
      this.service.locationSearch(post).subscribe((res:any)=>{
        if(res !=null || res=="OK"){
          this.location.locationTrue=true;
          localStorage.setItem('locationTrue', 'true');
        }else{
          this.location.locationTrue=false;
          localStorage.setItem('locationTrue', 'false');
          this.handler.err('Selected service is not provided in this region!!! Please select different region');
        }
      },err =>{
        this.location.locationTrue=false;
        localStorage.setItem('locationTrue', 'false');
        this.handler.err(err);
      })
    }else{
      var post1={
        "id":790,
        "region":this.purrchaseItems.delCity
      }
      this.service.locationSearch(post1).subscribe((res:any)=>{
        if(res !=null){
          this.location.locationTrue=true;
          localStorage.setItem('locationTrue', 'true');
        }else{
          this.location.locationTrue=false;
          localStorage.setItem('locationTrue', 'false');
          this.handler.err('Selected service is not provided in this region!!! Please select different region');
        }
      },err =>{
        this.location.locationTrue=false;
        localStorage.setItem('locationTrue', 'false');
        this.handler.err(err);
      })
    }
    
    }
      
  applyDiscount(){
    this.pdf.loader = true;
    if(this.discountAmt){
      this.discountAmt = this.discountAmt.toUpperCase();
    }
    this.service.applyDiscountOrder(this.id,this.discountAmt).subscribe(res => {
      this.getOrderById();
      this.creditCheck=false;
      this.discountAmt = undefined;
    },
      err => {
        this.pdf.loader = false;
        this.handler.err(err)
      })

  }
  remove(){
    this.pdf.loader = true;
    this.service.applyDiscountOrderRemove(this.id,this.purrchaseItems.couponCode).subscribe(res => {
      this.getOrderById();
      this.creditCheck = true;
    },
      err => {
        this.pdf.loader = false;
        this.handler.err(err)
      })
  }

  applyCredit(){
    this.pdf.loader=true
    Object.assign(this.purrchaseItems,{"creditPoints": this.criditValue
  }) 
   this.service.applyCredits(this.id ,this.purrchaseItems).subscribe((res:any)=>{
    this.getOrderById();
    this.couponCheck=false;
  },
    err => {
      this.pdf.loader = false;
      this.handler.err(err)
   })


  }

  removeCredit(){
    this.pdf.loader = true;
    this.service.removeCredits(this.id).subscribe(res => {
      this.getOrderById();
      this.getUser();
      this.couponCheck = true;
    },
      err => {
        this.pdf.loader = false;
        this.handler.err(err)
      })
  }

  UpdateService(){
    Object.assign(this.purrchaseItems,{"notes": this.notes,"cnvcChargeApplied":true
  })      
  this.service.updateOrder(this.id,this.purrchaseItems).subscribe((res:any) =>{   
  
  })
}  
  
}
